// Sport scopes — generic names, each tenant configures display labels
export enum Scope {
  MIXTAS = 'MIXTAS',
  PELOTA_LENTA = 'PELOTA_LENTA',
  AFICIONADO = 'AFICIONADO',
  PALETA_CUERO = 'PALETA_CUERO',
  PALA_CORTA = 'PALA_CORTA',
  MANO = 'MANO',
}

export enum Modality {
  PREOLIMPICA = 'PREOLIMPICA',
  OLIMPICA = 'OLIMPICA',
  PALETA_GOMA = 'PALETA-GOMA',
  PALETA_CUERO = 'PALETA-CUERO',
  PALA_CORTA = 'PALA-CORTA',
  FRONT_BALL = 'FRONT-BALL',
  MANO = 'MANO',
  PREOLIMPICA_INDIVIDUAL = 'PREOLIMPICA-INDIVIDUAL',
  OLIMPICA_INDIVIDUAL = 'OLIMPICA-INDIVIDUAL',
  PALETA_GOMA_INDIVIDUAL = 'PALETA-GOMA-INDIVIDUAL',
}

export enum Category {
  QUERUBIN = 'QUERUBIN',
  PREBENJAMIN = 'PREBENJAMIN',
  BENJAMIN = 'BENJAMIN',
  ALEVIN = 'ALEVIN',
  INFANTIL = 'INFANTIL',
  CADETE = 'CADETE',
  JUVENIL = 'JUVENIL',
  SENIOR = 'SENIOR',
  MASTER = 'MASTER',
  MASTER50 = 'MASTER50',
  MASTER65 = 'MASTER65',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  MIXED = 'MIXED',
}

export enum CompetitionType {
  LEAGUE = 'LEAGUE',
  CUP = 'CUP',
}

export enum WeekDay {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 7,
}

export enum PaymentMethod {
  CARD = 'CARD',
  BANK = 'BANK',
}

export enum PaymentType {
  TEAMS = 'TEAMS',
  PLAYERS = 'PLAYERS',
  REFEREE = 'REFEREE',
  INDIVIDUAL = 'INDIVIDUAL',
  MEMBERSHIP = 'MEMBERSHIP',
  BONO = 'BONO',
}

export enum MovementType {
  INCOME = 'INCOME',
  EXPENDITURE = 'EXPENDITURE',
}

export enum ZoneType {
  AUTONOMICO = 'AUTONOMICO',
  ALICANTE = 'ALICANTE',
  VALENCIA = 'VALENCIA',
  CASTELLON = 'CASTELLON',
  JECV = 'JECV',
}

export enum ReceiptStatus {
  LINK_CREATED = 'LINK_CREATED',
  /**
   * Receipt awaiting the referee's signature without any club payment.
   * Initial state in `federation_deferred` mode (no payment link/gateway).
   */
  READY_TO_SIGN = 'READY_TO_SIGN',
  PAYMENT_PAID = 'PAYMENT_PAID',
  SIGNED = 'SIGNED',
  FEDERATION_PAID = 'FEDERATION_PAID',
}

export enum InvoiceType {
  CLUBS = 'CLUBS',
  REFEREE = 'REFEREE',
}
